<template>
  <div>
    <notification-pop-up />
    <notification-animation />
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import { NotificationMixin } from '../../mixins/notification';
import { mapActions, mapGetters } from 'vuex';
import NotificationPopUp from './NotificationPopUp';
import NotificationAnimation from './NotificationAnimation';
import { getNotificationAfterBackPage } from '../../utils/notifications';

export default {
  components: { NotificationAnimation, NotificationPopUp },
  mixins: [component, NotificationMixin],
  computed: {
    ...mapGetters('notifications', ['isQueueNotification', 'allNotificationsQueued']),
  },
  watch: {
    isQueueNotification: function(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.showListRewardNotification();
      }
    },
  },
  created() {
    setTimeout(() => {
      this.setNotificationsQueue(getNotificationAfterBackPage()).then(() => {
        if (!this.isQueueNotification) {
          this.showListRewardNotification();
        }
      });
    }, 2000);
  },
  methods: {
    ...mapActions({
      setNotificationsQueue: 'notifications/setNotificationsQueue',
    }),
    showListRewardNotification() {
      for (let i = 0; i < this.allNotificationsQueued.length; i++) {
        this.receiveNotification(this.allNotificationsQueued[i]);
      }
      this.setNotificationsQueue([]);
    },
  },
};
</script>
